// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ColumnHeader, ColumnHeaderSchema } from 'api/gen/ColumnHeader';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagement, PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema } from 'api/gen/PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagement';

const requiredPart = t.interface({
  headers: t.union([t.array(ColumnHeaderSchema), t.null]),
  pagedModel: PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema,
});

export const DynamicPagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema = excess(requiredPart);

export interface DynamicPagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagement extends t.TypeOf<typeof DynamicPagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema> {}
